export enum HomeSection {
  ABOUT_US = 'home-about-us',
  OUR_BRANDS = 'home-our-brands',
  PILLARS = 'home-pillars',
  EDUCATION = 'home-education',
  REVIEWS = 'home-reviews',
}
